export default "__VITE_ASSET__CtDi0gOJ__"